/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: api.ts
 🗓️ Created: 2025-01-21
 🔁 Last Updated: 2025-01-03 by Rodrigo Cuadra (Added Domain Filtering)
 ────────────────────────────────────────────────────────────────*/

import { api } from '../../lib/api';

export interface WeakPasswordReport {
    extension: string;
    extensionName: string;
    type: 'device_password';
    weakness: string;
    resource: string;
}

export const fetchWeakPasswords = async (domainId?: number): Promise<WeakPasswordReport[]> => {
    const params = domainId != null ? { domainId: domainId.toString() } : {};
    const queryString = new URLSearchParams(params).toString();
    const url = queryString ? `/api/telephony/weak-passwords?${queryString}` : '/api/telephony/weak-passwords';

    try {
        const response = await api.get<{ data: WeakPasswordReport[] }>(url);
        return response.data.data || [];
    } catch (error) {
        console.error('[WeakPasswords API] Error:', error);
        throw error;
    }
};

